<script setup lang="ts">
  import { usePortKlaipeda } from '@/store/portKlaipeda';
  import { ref } from 'vue';
  import ButtonCustom from '@/components/components/buttonCustom.vue';
  import { formatLabel } from '../helpers/helper';

  const vin = ref<string>('');
  const { getData } = usePortKlaipeda();
  const dataCar = ref(null);
  const visibleDetailsBlock = ref<boolean>(false);
  const photosUsa = ref([]);
  const search = async () => {
    if (!vin.value) return;
    dataCar.value = await getData(vin.value);
    photosUsa.value =
      dataCar.value?.data_car?.upload
        ?.split('; ')
        .map((pair) => pair.trim())
        .filter((pair) => pair !== '0' && pair !== '0;')
        .map((pair) => {
          const cleanedPair = pair.replace(';', '');
          return cleanedPair.includes('cdn.liontrans')
            ? cleanedPair
            : `https://cdn.liontrans.com/${cleanedPair}`;
        }) ??
      dataCar.value?.data_car?.upload_new
        ?.split('; ')
        .map((pair) => pair.trim())
        .filter((pair) => pair !== '0' && pair !== '0;')
        .map((pair) => {
          const cleanedPair = pair.replace(';', '');
          return cleanedPair.includes('lnt1.nbg1.your-objectstorage')
            ? cleanedPair
            : `https://lnt1.nbg1.your-objectstorage.com/${cleanedPair}`;
        }) ??
      [];

    console.log(photosUsa, dataCar.value);
  };
</script>

<template>
  <div>
    <Card>
      <template #content>
        <div class="flex justify-between flex-1 text-xl">
          Check photos in the USA port:
        </div>
      </template>
    </Card>
    <Card class="mt-2">
      <template #content>
        <div class="flex justify-between flex-1">
          <IftaLabel class="w-full">
            <InputText id="vin-code" v-model="vin" />
            <label for="vin-code">Vin Code:</label>
          </IftaLabel>
        </div>
      </template>
    </Card>
    <Card class="mt-2">
      <template #content>
        <div class="flex justify-between flex-1">
          <button-custom @click="search" title="Search" />
        </div>
      </template>
    </Card>
    <Card class="mt-2" v-if="photosUsa.length > 0">
      <template #title>Photos from USA port:</template>
      <template #content>
        <Carousel
          v-if="photosUsa.length > 0"
          :value="photosUsa"
          :numVisible="1"
          :numScroll="1"
        >
          <template #item="itemProps">
            <Image alt="Image" preview>
              <template #previewicon>
                <i class="pi pi-search"></i>
              </template>
              <template #image>
                <img :src="itemProps.data" alt="image" />
              </template>
              <template #preview="previewProps">
                <img
                  :src="itemProps.data"
                  alt="preview"
                  :style="previewProps.style"
                  @click="previewProps.onClick"
                />
              </template>
            </Image>
          </template>
        </Carousel>
      </template>
    </Card>
    <Card class="stats-card mt-2" v-if="dataCar">
      <template #content>
        <div class="flex justify-between flex-1">
          <button-custom
            @click="visibleDetailsBlock = true"
            title="Show Car Detail Info"
          />
        </div>
      </template>
    </Card>
    <Drawer
      v-model:visible="visibleDetailsBlock"
      header="Details"
      position="right"
      class="!bg-gray-50"
    >
      <div class="flex flex-col gap-2">
        <div
          v-for="key in [
            'booking_number',
            'container_number',
            'container_line',
            'date_of_loading',
            'deliver_date',
            'expect_delivery',
            'geoport',
            'lot',
            'year',
            'manufacturer',
            'model',
            'sale_date',
            'vin',
            'key_status',
          ]"
          :key="key"
        >
          <hr class="mb-2" />
          <div class="d-flex justify-between">
            <div class="font-bold min-w-[200px] text-left">
              {{ formatLabel(key) }}
            </div>
            <div>{{ dataCar?.data_car?.[key] }}</div>
          </div>
          <hr class="mt-2" />
        </div>
      </div>
    </Drawer>
  </div>
</template>

<style scoped></style>
